import { EXPLORER } from '@/constants/services';
import { stakedAmount, stakedTxHash, stakedTxStatus, writeTxErrorMessage } from '@/pages/_app';
import { motion } from 'framer-motion';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import BigWhiteButton from '../general/BigWhiteButton';
import { CenterFoldContainer, TopText } from '../general/CenterFold';
import ParticleContainer from './ParticleContainer';
import { PossibleModes } from './StakeTopFold';

type Props = {
  setMode: (mode: PossibleModes) => void;
  hash?: string;
  amount?: string;
  status?: string;
  errorMessage?: string;
  reset?: () => void;
};

function LoadingWindow(props: Props) {
  return (
    <InnerWindow
      initial={{ opacity: 0.8, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      {props.hash ? (
        <TopText>
          Your transaction is loading. You can view it on Etherscan by clicking{' '}
          <a rel="norefferer" target="_blank" href={`${EXPLORER}/tx/${props.hash}`}>
            here
          </a>
          .
        </TopText>
      ) : (
        <TopText>
          Please sign the transaction with your wallet, the hash will show up shortly.
        </TopText>
      )}
    </InnerWindow>
  );
}
function ErrorWindow(props: Props) {
  const [txStatus, setTxStatus] = useAtom(stakedTxStatus);
  return (
    <InnerWindow
      initial={{ opacity: 0.8, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      <TopText>
        Sorry, something wrong happened. Here is the error message: {props.errorMessage}
      </TopText>
      <div style={{ flexGrow: 1 }} />
      <BigWhiteButton
        text="Go Back"
        onClick={() => {
          console.log('status', txStatus);
          props.reset?.();

          props.setMode('Withdrawals');
          setTxStatus('None');
        }}
      />
    </InnerWindow>
  );
}

function ReadyWindow({ setMode, amount, reset }: Props) {
  const amountOfMevETH = amount; // todo: get this from somewhere
  return (
    <InnerWindow
      initial={{ opacity: 0.0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.275 }}
    >
      <TopText id="ready-text">
        You've successfully withdrawn {amountOfMevETH} ETH from mevETH.
      </TopText>
      <div style={{ flexGrow: 1 }} />
      <BigWhiteButton
        text="Check your claimable tickets"
        onClick={() => {
          setMode('Withdrawals');
          reset?.();
        }}
      />
    </InnerWindow>
  );
}

function ConfirmStakeView({ setMode, reset }: Props) {
  const [amount] = useAtom(stakedAmount);
  const [hash] = useAtom(stakedTxHash);
  const [txErrorMessage] = useAtom(writeTxErrorMessage);
  const [txStatus] = useAtom(stakedTxStatus);

  let InnerWindow = LoadingWindow;
  if (txStatus === 'Success') {
    InnerWindow = ReadyWindow;
  } else if (txStatus === 'Error') {
    InnerWindow = ErrorWindow;
  }

  return (
    <CenterFoldContainer>
      <InnerWindow
        setMode={setMode}
        amount={amount}
        hash={hash}
        status={txStatus}
        errorMessage={txErrorMessage}
        reset={reset}
      />
      <ParticleContainer shouldTrigger={txStatus === 'Success'} />
    </CenterFoldContainer>
  );
}

const InnerWindow = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export default ConfirmStakeView;
